/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reset_ApplicationInputs */

const en_reset_application = /** @type {(inputs: Reset_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset Application`)
};

const fr_reset_application = /** @type {(inputs: Reset_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réinitialiser l'application`)
};

const de_reset_application = /** @type {(inputs: Reset_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anwendung zurücksetzen`)
};

const it_reset_application = /** @type {(inputs: Reset_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reimposta applicazione`)
};

const ru_reset_application = /** @type {(inputs: Reset_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сбросить приложение`)
};

const es_reset_application = /** @type {(inputs: Reset_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restablecer aplicación`)
};

const zh_cn2_reset_application = /** @type {(inputs: Reset_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重置应用程序`)
};

const ja_reset_application = /** @type {(inputs: Reset_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アプリケーションをリセットする`)
};

const hi_reset_application = /** @type {(inputs: Reset_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एप्लिकेशन रीसेट करें`)
};

const pt_pt2_reset_application = /** @type {(inputs: Reset_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redefinir aplicativo`)
};

/**
* | output |
* | --- |
* | "Reset Application" |
*
* @param {Reset_ApplicationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const reset_application = /** @type {((inputs?: Reset_ApplicationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reset_ApplicationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_reset_application(inputs)
	if (locale === "de") return de_reset_application(inputs)
	if (locale === "it") return it_reset_application(inputs)
	if (locale === "ru") return ru_reset_application(inputs)
	if (locale === "es") return es_reset_application(inputs)
	if (locale === "zh-CN") return zh_cn2_reset_application(inputs)
	if (locale === "ja") return ja_reset_application(inputs)
	if (locale === "hi") return hi_reset_application(inputs)
	if (locale === "pt-PT") return pt_pt2_reset_application(inputs)
	return en_reset_application(inputs)
});